import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-root">
        <div className="navigation-container">
          <div className="navigation-side-left navigation-side">
            <a href="Homepage">
              <div className="navigation-link">
                <span>Kitchen</span>
              </div>
            </a>
            <a href="Homepage">
              <div className="navigation-link">
                <span>Serving</span>
              </div>
            </a>
            <a href="Homepage">
              <div className="navigation-link">
                <span>Occasions</span>
              </div>
            </a>
          </div>
          <div className="navigation-logo-wrapper">
            <a href="Homepage">
              <div className="navigation-logo-link">
                <span className="section-title navigation-brand">Evelynis</span>
              </div>
            </a>
          </div>
          <div className="navigation-side-right navigation-side">
            <a href="Homepage">
              <div className="navigation-link">
                <span>The Workshop</span>
              </div>
            </a>
            <a href="Homepage">
              <div className="navigation-link">
                <span>Christmas</span>
              </div>
            </a>
            <button aria-label="Shopping Bag" className="navigation-icon-btn">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 10a4 4 0 0 1-8 0M3.103 6.034h17.794"></path>
                  <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"></path>
                </g>
              </svg>
            </button>
          </div>
          <button
            id="navToggle"
            aria-label="Open Menu"
            aria-expanded="false"
            className="navigation-mobile-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 5h16M4 12h16M4 19h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-overlay-header">
          <a href="Homepage">
            <div className="navigation-logo-link">
              <span className="section-title navigation-brand">Evelynis</span>
            </div>
          </a>
          <button
            id="navClose"
            aria-label="Close Menu"
            className="navigation-icon-btn"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="3" rx="2" width="18" height="18"></rect>
                <path d="M3 9h18M9 16l3-3l3 3"></path>
              </g>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <a href="Homepage">
            <div className="navigation-overlay-link">
              <span>Kitchen</span>
            </div>
          </a>
          <a href="Homepage">
            <div className="navigation-overlay-link">
              <span>Serving</span>
            </div>
          </a>
          <a href="Homepage">
            <div className="navigation-overlay-link">
              <span>Occasions</span>
            </div>
          </a>
          <a href="Homepage">
            <div className="navigation-overlay-link">
              <span>The Workshop</span>
            </div>
          </a>
          <a href="Homepage">
            <div className="navigation-overlay-link">
              <span>Christmas</span>
            </div>
          </a>
          <div className="navigation-overlay-footer">
            <button className="btn-primary btn btn-lg">Shop Collection</button>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById("navToggle")
  const navClose = document.getElementById("navClose")
  const mobileOverlay = document.getElementById("mobileOverlay")

  const openMenu = () => {
    mobileOverlay.style.display = "flex"
    // Small delay to ensure display: flex is applied before adding active class for transition
    setTimeout(() => {
      mobileOverlay.classList.add("is-active")
      navToggle.setAttribute("aria-expanded", "true")
      document.body.style.overflow = "hidden"
    }, 10)
  }

  const closeMenu = () => {
    mobileOverlay.classList.remove("is-active")
    navToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""

    // Wait for transition to finish before hiding display
    setTimeout(() => {
      if (!mobileOverlay.classList.contains("is-active")) {
        mobileOverlay.style.display = "none"
      }
    }, 400)
  }

  navToggle.addEventListener("click", openMenu)
  navClose.addEventListener("click", closeMenu)

  // Close menu when clicking on a link
  const overlayLinks = document.querySelectorAll(".navigation-overlay-link")
  overlayLinks.forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  // Accessibility: Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && mobileOverlay.classList.contains("is-active")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
